import { EventSource } from "eventsource";
import { getRequestWithAuth, postRequestWithAuth } from "../api";

export const getAllSessions = async () => {
  const response = await getRequestWithAuth("/api/v1/chat/allSessions");
  return response;
};

export const renameSession = async (sessionId: string, title: string) => {
  const response = await postRequestWithAuth(
    `/api/v1/chat/renameSession`,
    {
      session_id: sessionId,
      title: title,
    },
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return response;
};

export const deleteSession = async (sessionId: string) => {
  const response = await postRequestWithAuth(
    "/api/v1/chat/deleteSession",
    {
      session_id: sessionId,
    },
    {
      headers: {
        Accept: "application/json",
      },
    }
  );

  return response;
};

export const getSession = async (sessionId: string) => {
  const response = await getRequestWithAuth(
    `/api/v1/chat/session?session_id=${sessionId}`
  );
  return response;
};
